import React, { Component } from 'react';
import { Button, Row, Col, Modal, Form, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { withTranslation } from "react-i18next";
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import { connect } from 'react-redux';
import { compose } from 'redux';
import SignalRService from '../../controllers/SignalRService';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { duotone, solid } from '@fortawesome/fontawesome-svg-core/import.macro';

class Pause extends Component {

    constructor(props) {
        super(props)

        this.state = {
            pauses: [],
            loading: false,
            pauseId: -1,
            showComment: false,
            comment: ""
        }

        this.pausesResult = this.pausesResult.bind(this);
        this.changePause = this.changePause.bind(this);
        this.setComment = this.setComment.bind(this);
        this.setPause = this.setPause.bind(this);
        SignalRService.registerPausesListEvent(this.pausesResult);
    }

    onShow = e => {
        this.setLoading(true);
        SignalRService.getPausesList({ Extension: this.props.extension, UserId: this.props.userId }, x => { });
    }

    setLoading(value) {
        this.setState({
            loading: value
        })
    }

    pausesResult(pauses) {
        if (pauses !== null && pauses.length > 0) {
            this.setState({
                loading: false,
                pauses: pauses,
                pauseId: pauses[0].typeId,
                showComment: pauses[0].canComment
            })
        }
    }

    changePause = e => {
        let pauseId = parseInt(e.target.value),
            pause = this.state.pauses.find(x => x.typeId === pauseId);
        this.setState({
            pauseId: parseInt(e.target.value),
            showComment: pause.canComment
        })
    };

    setComment(e) {
        e.preventDefault();
        this.setState({
            comment: e.target.value
        });
    }

    setPause(e) {
        e.preventDefault();
        SignalRService.pauseACD({ Extension: this.props.extension, UserId: this.props.userId, TypeId: this.state.pauseId, Cause: this.state.comment }, x => { });
        this.props.toggleModal();
    }

    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.toggleModal} onShow={this.onShow} size="lg">
                <BlockUi tag="div" blocking={this.state.loading} color="#009ef7" message={this.props.t("pleasewait")}>
                    <Modal.Header >
                        <Modal.Title><FontAwesomeIcon icon={duotone("pause")} /> {this.props.t("pause")}</Modal.Title>
                        <OverlayTrigger
                            placement="left"
                            delay={{ show: 250, hide: 400 }}
                            overlay={<Tooltip style={{ position: "fixed" }}>
                                {this.props.t("close")}
                            </Tooltip>}>
                            <Button onClick={this.props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                        </OverlayTrigger>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col>
                                <Form>
                                    <Form.Group className="mb-4" controlId="categories">
                                        <Form.Label>{this.props.t("pauses")}</Form.Label>
                                        <Form.Select onChange={this.changePause} value={this.state.pauseId}>
                                            {
                                                this.state.pauses.map(elem => {
                                                    return <option key={elem.typeId} value={elem.typeId}>{elem.description} {elem.timeOut > 0 ? "(" + elem.timeOut + " " + this.props.t("minutes") + ")" : ""}</option>
                                                })
                                            }
                                        </Form.Select>
                                    </Form.Group>
                                    {this.state.showComment &&
                                        <Form.Group className="mb-4" controlId="fcpausecomment">
                                            <Form.Label>{this.props.t("comment")}</Form.Label>
                                            <Form.Control type="text" value={this.state.comment} onChange={this.setComment} />
                                        </Form.Group>
                                    }
                                </Form>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" onClick={this.setPause}> <FontAwesomeIcon icon={duotone("pause")} /> {this.props.t("pause")}</Button>
                    </Modal.Footer>
                </BlockUi>
            </Modal>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        name: state.agent.name,
        status: state.agent.status,
        shortExtension: state.agent.shortExtension,
        photo: state.agent.photo,
        initials: state.agent.initials,
        duple: state.agent.duple,
        extension: state.agent.extension,
        userId: state.agent.userId
    };
};

export default compose(connect(mapStateToProps), withTranslation())(Pause);
